function menuDrawer() {
  const hamburgerIcon = document.querySelector('.menu-hamburger__btn');
  const closeIcon = document.querySelector('.menu-close__btn');
  const menuDrawer = document.querySelector('.menu-drawer');
  const menuDrawerBox = document.querySelector('.menu-drawer__box');
  const menuItems = document.querySelectorAll('.dropdown-list__item.has-dropdown > a');
  if (hamburgerIcon) {
    hamburgerIcon.addEventListener('click', () => {
      menuDrawer.classList.add('active');
    });
  }
  if (closeIcon) {
    closeIcon.addEventListener('click', () => {
      menuDrawer.classList.remove('active');
    });
  }
  if (menuDrawer) {
    menuDrawer.addEventListener('click', () => {
      menuDrawer.classList.remove('active');
    });
  }
  if (menuDrawerBox) {
    menuDrawerBox.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }
  menuItems.forEach(item => {
    if (item) {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        item.classList.toggle('active');
        const childMenu = item.closest('.dropdown-list__item').querySelector('.drawer-menu__list--child');
        if (childMenu) {
          childMenu.classList.toggle('active');
        }
      });
    }
  });
  
}
function backToTop() {
  const backBtn = document.querySelector('.scroll-top__btn');
  if (backBtn) {
    backBtn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}
function footerContentDrawer() {
  const menuLinks = document.querySelectorAll('.footer-link__item a');
  const drawer = document.querySelector('.custom-footer__content--drawer');
  const drawerBox = document.querySelector('.custom-footer__drawer--box');
  const drawerContent = drawer.querySelector('.custom-footer__box--content');
  const closeButton = drawer.querySelector('.custom-footer__box--close-btn');
  
  const showLoadingState = () => {
    drawer.classList.add('active');
  };

  const openDrawer = (content) => {
    drawerContent.innerHTML = content;
    drawer.classList.add('active');
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    drawerContent.innerHTML = '';
  };

  const fetchContent = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const targetContent = doc.querySelector('main');
      return targetContent ? targetContent.innerHTML : '<p>Content not found.</p>';
    } catch (error) {
      console.error('Error fetching content:', error);
      return '<p>Failed to load content. Please try again later.</p>';
    }
  };

  menuLinks.forEach(link => {
    if (link) {
      link.addEventListener('click', async (event) => {
        const linkHref = link.getAttribute('href');
        const isExternalLink = linkHref.startsWith('http');
        if (isExternalLink) {
          link.setAttribute('target', '_blank');
        } else {
          event.preventDefault();
          showLoadingState();
          const content = await fetchContent(linkHref);
          openDrawer(content);
        }
      });
    }
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }

  if (drawerBox) {
    drawerBox.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }

  if (drawer) {
    drawer.addEventListener('click', closeDrawer);
  }
}
function contactSideBar() {
  const sidebarIcon = document.querySelector('.contact-sidebar__btn');
  const closeIcon = document.querySelector('.sidebar-close__btn');
  const sidebarDrawer = document.querySelector('.contact-form__sidebar');
  const sidebarDrawerBox = document.querySelector('.contact-sidebar__box');
  if (sidebarIcon) {
    sidebarIcon.addEventListener('click', () => {
      sidebarDrawer.classList.add('active');
    });
  }
  if (closeIcon) {
    closeIcon.addEventListener('click', () => {
      sidebarDrawer.classList.remove('active');
    });
  }
  if (sidebarDrawer) {
    sidebarDrawer.addEventListener('click', () => {
      sidebarDrawer.classList.remove('active');
    });
  }
  if (sidebarDrawerBox) {
    sidebarDrawerBox.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }
}
function headerEvents() {
  const header = document.querySelector(".custom-header__home");
  const triggerHeight = 100;

  window.addEventListener("scroll", function () {
    if (window.scrollY > triggerHeight) {
      header.classList.add("transparent");
    } else {
      header.classList.remove("transparent");
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  menuDrawer();
  backToTop();
  footerContentDrawer();
  contactSideBar();
  headerEvents();
});